import React from 'react';
import { Link, LinkOff } from '@mui/icons-material';
import { StatusTitle, StatusWrap } from './styles';

const statusLabelMap = {
  connected: (
    <>
      <Link className="icon" /> Cable connected
    </>
  ),
  disconnected: (
    <>
      <LinkOff className="icon" /> Cable disconnected
    </>
  ),
};

function CableStatusComponent(props) {
  const { status } = props;

  return (
    <StatusWrap>
      <StatusTitle>{statusLabelMap[status]}</StatusTitle>
    </StatusWrap>
  );
}

export default CableStatusComponent;
